export const PRODUCT_IMAGES = [
  '/images/checkmate-mall/card-1.webp',
  '/images/checkmate-mall/card-2.webp',
  '/images/checkmate-mall/card-3.webp',
  '/images/checkmate-mall/card-4.webp',
];

export const AUTO_SLIDE_INTERVAL = 3000; // 3 seconds
